/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Eishita",
  logo_name: "</Eishita>",
  // nickname: "harry / picleric",
  full_name: "Eishita Gupta",
  subTitle:
    "Android Application Developer",
  resumeLink:
    "https://drive.google.com/",
  mail: "eg7409@srmist.edu.in",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/eg7409",
  linkedin: "https://www.linkedin.com/in/eishita-gupta-31564b156/",
  gmail: "eg7409@srmist.edu.in",
  // gitlab: "https://gitlab.com/harikanani",
  facebook: "https://www.facebook.com/",
  twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive User Interfaces and Backend for Mobile applications",
        "⚡ Creating application backend in Java",
        "⚡ Integration of third party services such as Firebase/ AWS / GCP",
      ],
      softwareSkills: [
       
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
      
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
       
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
            },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "SRM Institute of Science and Technology",
      subtitle: "Bachelors in Computer Science and Engineering",
      logo_path: "SRM_Logo.png",
      alt_name: "SSEC",
      duration: "2019 - 2023",
      descriptions: [
        "I'm currently pursuing my Bachelors in Computer Science and Engineering.",
        "Cgpa : 9.52/10"
        // "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        // "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        // "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "https://www.srmist.edu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Google",
      subtitle: "Google KickStart",
      logo_path: "kickstart.png",
      // certificate_link:
      //   "https://drive.google.com/",
      alt_name: "Reply",
      // color_code: "#2AAFED",
      color_code: "#202020",
    },
    
    {
      title: "Cognizant",
      subtitle: "Code Gladitors 2021",
      logo_path: "gladitors.jpg",
      // certificate_link:
      //   "https://drive.google.com/file/d/",
      alt_name: "hackathon",
      color_code: "#fffbf3",
    },
    
    {
      title: "Flipkart",
      subtitle: "Flipkart GRiD 3.0",
      logo_path: "flipkart.png",
      // certificate_link:
      //   "https://drive.google.com/file/d/",
      alt_name: "Opensource Event",
      color_code: "#000000",
    },
    
    {
      title: "Aptitude Buster",
      subtitle: "National Aptitude Buster",
      logo_path: "aptitude.png",
      // certificate_link:
      //   "https://drive.google.com/file/d/",
      alt_name: "Postman",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "Competitive Programming",
      subtitle: "Reply Challenges",
      logo_path: "Reply.jfif",
      // certificate_link:
      //   "https://drive.google.com/file/d",
      alt_name: "Reply",
      color_code: "#2AAFED",
    },
    {
      title: "Google",
      subtitle: "Google Hash Code",
      logo_path: "hashcode.jpg",
      // certificate_link:
      //   "https://drive.google.com/file/d/",
      alt_name: "Reply",
      color_code: "#484848",
    },
    
    {
      title: "Google",
      subtitle: "Google Codejam",
      logo_path: "codejam.jpg",
      // certificate_link:
      //   "https://drive.google.com/",
      alt_name: "Reply",
      color_code: "#fffbf3",
    },
    {
      title: "American Express",
      subtitle: "Geek Goddess 2021",
      logo_path: "american.jpeg",
      // certificate_link:
      //   "https://drive.google.com/file/d",
      alt_name: "Reply",
      color_code: "#fffbf3",
    },
    {
      title: "Tech Challenge",
      subtitle: "Capgemini Tech Challenge 2021 Edition",
      logo_path: "capgemini.png",
      // certificate_link:
      //   "https://drive.google.com/file/d/yview",
      alt_name: "Reply",
      color_code: "#88e7ce",
    },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've completed one internship. I've mostly done projects on my own and I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Software Engineer Intern",
          company: "Ciesta Technologies",
          company_url: "https://www.ciesta.in/",
          logo_path: "Ciesta.jpeg",
          duration: "May 2021 - June 2021",
          location: "Remote",
          description: `• Key Skills – Android Application Development, Java                       
                        • Build an Android Application YLIFE          
          `,
          // "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
          color: "#0071C5",
        }
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Application Developer",
          company: "Webarch Club",
          company_url: "https://www.webarchsrm.com/",
          logo_path: "Webarch.jfif",
          duration: "March 2021 - Present",
          location: "SRM IST Kattankulathur",
          description:
            "Member responsibilities were to help students in project planning, review issues and pull requests, ensure smooth progress and help juniors out in their difficulties.",
          color: "#4285F4",
        },
        {
          title: "Competitive Programmer",
          company: "CSE Association",
          company_url: "https://in.linkedin.com/company/cse-association-srm",
          logo_path: "csea.png",
          duration: "March 2021 - Present",
          location: "SRM IST Kattankulathur",
          description:
            "Member responsibilities were to help students in coding, ensure smooth progress and help juniors out in their difficulties.",
          color: "#a60000",
        },
        {
          title: "Committee Head",
          company: "Social Club",
          // company_url: "/",
          logo_path: "social.png",
          duration: "Oct 2021 - Present",
          location: "SRM IST Kattankulathur",
          description:
            "Committee Head of Publicity Domain.",
          color: "#62cff0",
        },
        {
          title: "Volunteer",
          company: "Google Crowdsource",
          company_url: "https://crowdsource.google.com/",
          logo_path: "GCS.jfif",
          duration: "Sept 2020 - Present",
          location: "Remote",
          description:
            "As a member of the global Crowdsource community one can gain recognition from other Crowdsourcers and Google.",
          color: "#ffffff",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My best experience is to create Android Application. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "waving.gif",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "",
    subtitle:
      "",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Animax",
      url: "https://github.com/eg7409",
      description:
        "This is a social media application that allows users to upload and watch videos, read and evaluate movie/series descriptions, and talk anonymously.",
      languages: [
        {
          name: "Android Studio",
          iconifyClass: "mdi:android-studio",
        },
        {
          name: "Android",
          iconifyClass: "akar-icons:android-fill",
        },
        {
          name: "Java",
          iconifyClass: "fa-brands:java",
        },
        {
          name: "Firebase",
          iconifyClass: "ion:logo-firebase",
        },
      ],
    },
    {
      id: "1",
      name: "Kudos",
      url: "https://github.com/eg7409",
      description:
        "This application is a chat app with unique features such as anonymous names and all users can talk at the same time.",
      languages: [
        {
          name: "Android Studio",
          iconifyClass: "mdi:android-studio",
        },
        {
          name: "Android",
          iconifyClass: "akar-icons:android-fill",
        },
        {
          name: "Java",
          iconifyClass: "fa-brands:java",
        },
      ],
    },
    {
      id: "2",
      name: "Quizpicable Me",
      url: "https://github.com/eg7409",
      description:
        "The application asks the user questions at random with four possibilities, and at the end of the quiz, the user's score and right answers are displayed.",
      languages: [
        {
          name: "Android Studio",
          iconifyClass: "mdi:android-studio",
        },
        {
          name: "Android",
          iconifyClass: "akar-icons:android-fill",
        },
        {
          name: "Java",
          iconifyClass: "fa-brands:java",
        },
      ],
    },
    {
      id: "3",
      name: "Taylor Swift Quotes",
      url: "https://github.com/eg7409",
      description:
        "The application makes use of a quotes API and on a refresh each time a new quote appears on the screen.",
      languages: [
        {
          name: "Android Studio",
          iconifyClass: "mdi:android-studio",
        },
        {
          name: "Android",
          iconifyClass: "akar-icons:android-fill",
        },
        {
          name: "Java",
          iconifyClass: "fa-brands:java",
        },
      ],
    },
    {
      id: "4",
      name: "Infinity-I/O",
      url: "https://github.com/eg7409",
      description:
        "It's a video app similar to Instagram's reels.",
      languages: [
        {
          name: "Android Studio",
          iconifyClass: "mdi:android-studio",
        },
        {
          name: "Android",
          iconifyClass: "akar-icons:android-fill",
        },
        {
          name: "Java",
          iconifyClass: "fa-brands:java",
        },
        {
          name: "Firebase",
          iconifyClass: "ion:logo-firebase",
        },
      ],
    },
    {
      id: "5",
      name: "Sizzling Food",
      url: "https://github.com/eg7409",
      description:
        "A food delivery app that allows you to browse menus from your favourite restaurants and place orders without having to leave your house.",
      languages: [
        {
          name: "Android Studio",
          iconifyClass: "mdi:android-studio",
        },
        {
          name: "Android",
          iconifyClass: "akar-icons:android-fill",
        },
        {
          name: "Java",
          iconifyClass: "fa-brands:java",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
